































import Vue, { PropType } from "vue";
import CurriculumJournalRow from "@/views/curriculum/components/CurriculumJournalRow/CurriculumJournalRow.vue";
import CurriculumJournalHeaderRow from "@/views/curriculum/components/CurriculumJournalHeaderRow/CurriculumJournalHeaderRow.vue";
import CurriculumReadMainHeader from "@/views/curriculum/student/components/CurriculumReadMainHeader/CurriculumReadMainHeader.vue";
import { EECurriculum } from "@/ts/objects/curriculum/value/EECurriculum";
import { IEECJournalTree } from "@/ts/objects/curriculum/IEECJournal";
import { Loadable } from "@/ts/Loadable";
import LoadingBlock from "@/components/loading/LoadingBlock.vue";

export default Vue.extend({
  name: "CurriculumStudentViewEEC",
  components: { LoadingBlock, CurriculumJournalRow, CurriculumJournalHeaderRow, CurriculumReadMainHeader },
  props: {
    /**
     * 児童生徒ID。
     */
    studentUserId: { type: String as PropType<string | null>, required: true },

    /**
     * 文書評価教科。
     */
    eeCurriculum: { type: Object as PropType<EECurriculum>, required: true },

    /**
     * 現在表示中の教科・児童生徒配下の学習記録。
     */
    journalTrees: { type: Object as PropType<Loadable<IEECJournalTree[]>>, required: true },
  },
  data(): {
    months: number[];
    monthColWidth: number;
    extraMenuColWidth: number;
    otherColMinWidth: number;

    /**
     * 現在ファイルビューを開いている学習記録のリソース名。
     */
    filesViewJournal: string | null;
  } {
    return {
      months: [4, 5, 6, 7, 8, 9, 10, 11, 12, 1, 2, 3],
      monthColWidth: 71,
      extraMenuColWidth: 20,
      otherColMinWidth: 110,

      filesViewJournal: null,
    };
  },
  computed: {
    styles(): Record<string, string> {
      return {
        "--monthColWidth": `${this.monthColWidth}px`,
        "--extraMenuColWidth": `${this.extraMenuColWidth}px`,
        "--otherColMinWidth": `${this.otherColMinWidth}px`,
      };
    },
  },
  methods: {
    /**
     * 現在ファイルビューを開いている学習記録を変更する。
     */
    selectFilesViewJournal(rname: string | null) {
      this.filesViewJournal = rname;
    },
  },
});
